<template>
    <div class="mobile" v-if="config.mobileVendorType[banner.name]">
        <div @click="openWindow(config.mobileVendorType[banner.name])">
            <img :alt="banner.alt" :src="banner.imageSrc" :class="`${banner.name}-button`"/>
        </div>
    </div>
</template>

<script>
/* global config */

export default {
    name: 'Banner',
    props: {
        banner: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config
        }
    },
    methods: {
        openWindow(url) {
            window.open(url);
        }
    }
}
</script>
